var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91189 1.815C6.91189 0.812591 7.73307 0 8.74523 0H10.5786V3.025C10.5786 3.35926 10.8536 3.63 11.1897 3.63H12.4119C12.748 3.63 13.023 3.35926 13.023 3.025V0H14.8563C15.8685 0 16.6897 0.812591 16.6897 1.815V6.655C16.6897 7.65703 15.8685 8.47 14.8563 8.47H8.74523C7.73307 8.47 6.91189 7.65703 6.91189 6.655V1.815ZM4.46745 10.89V13.915C4.46745 14.2478 4.74245 14.52 5.07856 14.52H6.30078C6.63689 14.52 6.91189 14.2478 6.91189 13.915V10.89H8.74523C9.75738 10.89 10.5786 11.703 10.5786 12.705V17.545C10.5786 18.547 9.75738 19.36 8.74523 19.36H2.63411C1.62158 19.36 0.800781 18.547 0.800781 17.545V12.705C0.800781 11.703 1.62158 10.89 2.63411 10.89H4.46745ZM16.6897 10.89V13.915C16.6897 14.2478 16.9647 14.52 17.3008 14.52H18.523C18.8591 14.52 19.1341 14.2478 19.1341 13.915V10.89H20.9674C21.9796 10.89 22.8008 11.703 22.8008 12.705V17.545C22.8008 18.547 21.9796 19.36 20.9674 19.36H14.8563C13.8442 19.36 13.023 18.547 13.023 17.545V12.705C13.023 11.703 13.8442 10.89 14.8563 10.89H16.6897Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.5d90e3a8448f19c2f771c6d8d344ce34.svg";
export { ForwardRef as ReactComponent };